import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';

import buildMetaProperty from '../../utils/buildMetaProperty';

const MetaTitle: React.FC = () => {
  const locale = useSelector(select.locale.get);
  const meta = useSelector(select.page.getMeta);
  const title = buildMetaProperty('title', meta, locale);

  if (!title) return null;

  return (
    <Helmet titleTemplate={meta?.titleTemplate?.replace(/\${pageTitle}/g, '%s')}>
      <title>{title}</title>
    </Helmet>
  );
};

export default MetaTitle;
